module.exports = __webpack_public_path__ + "img/pay.d8988435.png";